/**
 *  city-district-select.ctrl.js
 */

class CityDistrictSelectCtrl {
    constructor($state, $stateParams, cityDistrictSelectServ,$location) {

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$location = $location;

        this.district = { value: '' };
        this.city = { value: '' };

        cityDistrictSelectServ.getCitiesByDistrict().then((successResp) => {

            this.citiesByDistrict = successResp.data;

            this.districts = this.getDistricts(this.citiesByDistrict);

            if ($stateParams.district) {

                this.district.value = $stateParams.district;

                this.cities = this.getCities(this.citiesByDistrict, $stateParams.district);

                this.onDistrictChange();

                this.city.value = $stateParams.city;
            }
        });
    }

    /**
     *  Init.
     */

    getDistricts(citiesByDistrict) {
        return Object.keys(citiesByDistrict);
    }

    getCities(citiesByDistrict, district) {
        return citiesByDistrict[district];
    }

    onDistrictChange() {

        this.disableCitySelect = this.district.value ? false : true;

        this.cities = this.citiesByDistrict[this.district.value];
    }

    formSubmit(form) {
        if (form.$valid) {
            this.changeState(form.district.$modelValue, form.city.$modelValue);
        }
    }

    changeState(district, city) {
        if (district && city) {
            this.$state.go('shops-by-city', {
                district: district,
                city: city
            }, { reload: true });
        } else {
            if (district) {
                this.$state.go('shops-by-district', {
                    district: district
                }, { reload: true });
            }
        }
    }
}

CityDistrictSelectCtrl.$inject = ['$state', '$stateParams', 'cityDistrictSelectServ','$location'];

export default CityDistrictSelectCtrl;
